export class SiteLinkLightBoxInjector extends React.Component<{}, {}>{
    public static siteScriptName = "SiteLinkLightBoxInjector";
    coponentDidMount() {
        document["injectLinkLightBox"] = function (href, width, height) {
            const lightBoxStyle = { "background": "red", "position": "fixed", "width": "100%", "height": "100%" }
            const lightBox = document.createElement("div")
            lightBox.setAttribute('id', 'lightBox')
            lightBox.setAttribute('style', JSON.stringify(lightBoxStyle))
            const iframe = document.createElement("iframe")
            iframe.setAttribute('src', href)
            iframe.setAttribute('width', width)
            iframe.setAttribute('height', height)
            lightBox.appendChild(iframe)
            document.body.appendChild(lightBox)
        }
    }

    render() {
        return null
    }
}